import { defineStore } from 'pinia';
import { ref } from 'vue';

export const usePetAdsMapStore = defineStore('petAdsMap', () => {
  const petAdsMap = ref([]);
  const loading = ref(false);
  const error = ref(null);

  const setPetAds = (ads) => {
    petAdsMap.value = ads;
  };

  const getPetById = (id) => {
    return petAdsMap.value.find(ad => ad.id === id);
  };

  return {
    petAdsMap,
    loading,
    error,
    setPetAds,
    getPetById
  };
});